import { WithSpringConfig } from 'react-native-reanimated';

export const springConfig: Record<string, WithSpringConfig> = {
    default: {
        stiffness: 300,
        damping: 20,
        overshootClamping: true,
    },
};
